import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareFormSubmitClassicPublicRoute: InvariantJiraRoute = {
	name: 'software-form-submit-classic-public',
	path: '/jira/software/c/form/:formUuid',
	exact: true,
};
